import {
  Block,
  FlexGrid,
  FlexGridItem,
  LabelSmall,
  MatsCircle,
  ParagraphXSmall,
} from "@mezo-org/mezo-clay"

import { networkUtils } from "#/shared/utils"

export default function SidebarNavigationMatsnet() {
  return (
    <Block
      backgroundColor="gray50"
      padding="16px"
      overrides={{ Block: { style: () => ({ borderRadius: "16px" }) } }}
    >
      <FlexGrid flexGridColumnCount={2} marginBottom="4px" alignItems="center">
        <FlexGridItem maxWidth="28px" height="20px">
          <MatsCircle size={20} />
        </FlexGridItem>
        <FlexGridItem>
          <LabelSmall color="contentTertiary">
            {networkUtils.getMezoNetworkLabel()}
          </LabelSmall>
        </FlexGridItem>
      </FlexGrid>
      <ParagraphXSmall color="contentTertiary">
        Features that can only <br />
        accept {networkUtils.getMezoNetworkLabel()} assets <br />
        carry this mark.
      </ParagraphXSmall>
    </Block>
  )
}
